import React from "react";
//import "./styles.css";

import GoogleMap from "google-map-react";
//import MCircle from "./marker/Circle";
//import Pointer from "./marker/Pointer";



export default function Map(props) {
	const {geo_location, width, height, onDrag} = props;
	const [size, setSize] = React.useState({
		width: 250,
		height:235
	});
	const [center, setCenter] = React.useState({
		lat:33.862532, 
		lng: -117.802847
	});

	const [gmap, setGmap] = React.useState({});
	const [myMarker, setMyMarker] = React.useState(null);

	const extractLatLng = (gloc) => {
		if(!gloc) return {
			lat : 33.862532,
			lng : -117.802847
		}
		return {
			lat: parseFloat(gloc.split(',')[1].trim()),
			lng: parseFloat(gloc.split(',')[0].trim())
		};
	};
	
	const refreshMap = () => {
		console.log('calling refreshmap');
		let latlng = extractLatLng(geo_location);
		myMarker.setPosition(latlng);

		setCenter(latlng);
		gmap.map.panTo(latlng);
		
	}
	
	const loadMap = (map, maps) => {
		console.log('calling loadMap', map, maps);
		setGmap({map: map, maps : maps});
	
		let mlatlng = extractLatLng(geo_location);
		let geocoder = new maps.Geocoder();
		let marker = new maps.Marker({
			position: mlatlng,
			map,
			draggable: Boolean(onDrag)
		});
		setCenter(mlatlng);
		setMyMarker(marker);
		if(onDrag){
			maps.event.addListener(marker, "dragend", (dragres) => {
				let latlng = {
					lat: dragres.latLng.lat(),
					lng: dragres.latLng.lng()
				};
				setCenter(latlng);
				map.panTo(latlng);
				geocoder.geocode({latLng: dragres.latLng}, (res) => {
					if(res && res.length > 0){
						onDrag(latlng.lng+', '+latlng.lat, res[0].formatted_address)
					}
				});
			});
		}
	}
	//pan to new center
	React.useEffect(() => {
		if(gmap.maps && gmap.map)
			gmap.map.panTo(center);
	}, [center, gmap.maps, gmap.map]);
	//refresh on prop updates
	React.useEffect(() => {
		if(geo_location && gmap.maps && gmap.map)
			refreshMap();
		var newSize = Object.assign({}, size);
		if(width){
			newSize.width = width;
		}
		if(height){
			newSize.height = height;
		}
		setSize(newSize);
		
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [geo_location]);
  return (
	  <div style={{height: '100%', width: '100%', minHeight:200, overflow:'visible'}} >
      <GoogleMap
        bootstrapURLKeys={{
          key: process.env.REACT_APP_MAP_API_KEY,
          language: "en",
          region: "US",
		  libraries: ['places'],
        }}
	  	yesIWantToUseGoogleMapApiInternals
        defaultCenter={{
			lat:33.862532, 
			lng: -117.802847
		}}
        defaultZoom={14}
	  	onGoogleApiLoaded={({map, maps}) => loadMap(map, maps)}
      />
	</div>
  );
}
